if (!customElements.get("cart-items")) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.dataset.empty === "false" && this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      this.cartDrawer = document.getElementById("cart-drawer");
      this.itemStatus = document.getElementById("cart-line-item-status");

      this.currentTotalItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]')
      ).reduce((total, quantityInput) => total + parseInt(quantityInput.value, 10), 0);

      this.currentQuantities = [];
      this.querySelectorAll(".cart-item").forEach((item) => {
        this.currentQuantities[item.dataset.variantId] = Number(
          item.querySelector(".qty-input__input").value
        );
      });

      this.addEventListener("click", this.handleClick.bind(this));
      this.addEventListener("change", debounce(this.handleChange.bind(this)));
    }

    handleClick(evt) {
      if (evt.target.matches(".js-remove-item")) {
        evt.preventDefault();
        this.updateQuantity(evt.target.dataset.index, 0);
      }
    }

    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer
        ? this.cartDrawer.querySelector(".drawer__content")
        : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document
        .querySelectorAll(
          `.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`
        )
        .forEach((el) => {
          el.innerHTML = "";
          el.hidden = !0;
        });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname,
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;

        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();
        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        // --- FIX SUBTOTAL ---
        const subtotalTargets = document.querySelectorAll(
          "#cart-summary .limoniapps-discountninja-cart-subtotal-price, #cart-summary p.h6, #cart-summary [data-cart-subtotal]"
        );

        let subtotalCents = null;
        if (data.total_price) {
          subtotalCents = Number(data.total_price);
        } else if (data.items_subtotal_price) {
          subtotalCents = Number(data.items_subtotal_price);
        } else if (data.cart && data.cart.total_price) {
          subtotalCents = Number(data.cart.total_price);
        }

        if (subtotalCents !== null && !isNaN(subtotalCents)) {
          subtotalTargets.forEach((el) => {
            el.textContent = formatMoney(subtotalCents);
          });
        } else {
          console.warn("⚠️ No se encontró subtotal en la respuesta:", data);
        }
        // --- END FIX SUBTOTAL ---

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle("drawer__content--flex", newTotalQuantity === 0);
          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector("product-recommendations");
            recommendations && recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          const cartTitle = this.closest(".cc-main-cart").querySelector(".js-cart-title");
          cartTitle && (cartTitle.style.textAlign = "center");
          const cartSummaryCss = document.getElementById("cart-summary-css");
          cartSummaryCss && cartSummaryCss.remove();
          const cartSummary = document.getElementById("cart-summary");
          cartSummary && (cartSummary.hidden = !0);
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;
          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        window.initLazyImages && window.initLazyImages();

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);

        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        oldTotalQuantity !== newTotalQuantity &&
          this.dispatchEvent(
            new CustomEvent("on:line-item:change", {
              bubbles: !0,
              detail: {
                cart: data,
                variantId,
                oldQuantity: this.currentQuantities[variantId],
                newQuantity: Number(quantity),
              },
            })
          );

        this.currentQuantities[variantId] = Number(quantity);
        lineErrors.innerHTML = "";
        lineErrors.hidden = !0;
      } catch (error) {
        /^[0-9]+$/.test(error.message)
          ? (lineErrors.textContent = theme.strings.cartError)
          : (lineErrors.textContent = error.message),
          (lineErrors.hidden = !1),
          console.log(error),
          this.querySelectorAll(".cart-item__loader").forEach((loader) => {
            loader.hidden = !0;
          }),
          this.dispatchEvent(
            new CustomEvent("on:cart:error", {
              bubbles: !0,
              detail: { error: error.message },
            })
          );

        const input = document.getElementById(`quantity-${line}`);
        input.value = input.dataset.initialValue;
        input.closest("quantity-input").currentQty = input.dataset.initialValue;
      } finally {
        this.classList.remove("pointer-events-none");
        cartDrawerContent &&
          (requestAnimationFrame(() => {
            cartDrawerContent.scrollTop = cartDrawerContentScroll;
          }),
          setTimeout(() => {
            cartDrawerContent.scrollTop = cartDrawerContentScroll;
          }, 0),
          requestAnimationFrame(() => {
            this.cartDrawer.scrollTop = cartDrawerScroll;
          }),
          setTimeout(() => {
            this.cartDrawer.scrollTop = cartDrawerScroll;
          }, 0));
      }
    }

    async refresh() {
      const errors = document.getElementById("cart-errors");
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(!0);
          return;
        }
        const data = await response.json();
        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;
          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        const firstCartItem = this.querySelector(".cart-item:first-child");
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        window.initLazyImages && window.initLazyImages();
        errors.innerHTML = "";
        errors.hidden = !0;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = !1;
        console.log(error);
        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: !0,
            detail: { error: error.message },
          })
        );
      }
    }

    getSectionsToRender() {
      let sections = [
        { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
        { id: "free-shipping-notice", section: "free-shipping-notice", selector: ".free-shipping-notice" },
      ];
      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest(".shopify-section").id.replace("shopify-section-", "");
        sections = [
          ...sections,
          { id: "cart-items", section: cartDrawerId, selector: "cart-items" },
          { id: "cart-promoted-products", section: cartDrawerId, selector: "#cart-promoted-products" },
          { id: "cart-drawer", section: cartDrawerId, selector: ".cart-drawer__summary" },
          { id: "cart-drawer-media-promotion", section: cartDrawerId, selector: "#cart-drawer-media-promotion" },
        ];
      } else {
        sections = [
          ...sections,
          { id: "cart-items", section: this.dataset.section, selector: "cart-items" },
          { id: "cart-summary", section: document.getElementById("cart-summary").dataset.section, selector: ".cart__summary" },
        ];
      }
      return sections;
    }

    static getElementHTML(html, selector) {
      const tmpl = document.createElement("template");
      tmpl.innerHTML = html;
      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : "";
    }

    enableLoading(line) {
      this.classList.add("pointer-events-none");
      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      loader && (loader.hidden = !1);
      document.activeElement.blur();
      this.itemStatus && this.itemStatus.setAttribute("aria-hidden", "false");
    }

    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById("cart-recommendations");
      this.recommendations &&
        (productId
          ? ((this.recommendations.dataset.productId = productId), this.recommendations.init())
          : (this.recommendations.innerHTML = ""));
    }

    updateLiveRegions() {
      this.itemStatus.setAttribute("aria-hidden", "true");
      const cartStatus = document.getElementById("cart-live-region-text");
      cartStatus.setAttribute("aria-hidden", "false");
      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", "true");
      }, 1000);
    }

    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;
      lineItem && (activeEl = lineItem.querySelector(`[name="${name}"]`));
      this.cartDrawer
        ? lineItem && activeEl
          ? trapFocus(this.cartDrawer, activeEl)
          : itemCount === 0
          ? trapFocus(this.cartDrawer.querySelector(".js-cart-empty"), this.cartDrawer.querySelector("a"))
          : this.cartDrawer.querySelector(".cart-item") &&
            trapFocus(this.cartDrawer, document.querySelector(".js-item-name"))
        : lineItem && activeEl && activeEl.focus();
    }
  }

  customElements.define("cart-items", CartItems);
}
